// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * APPEND-ONLY. The members below carry no explicit `= N`, so `FlatBuffers`
 * numbers them by declaration order and the ordinal IS the wire value.
 *
 * Inserting, reordering or removing a member silently renumbers every member
 * after it, which reinterprets every archived message and every frame in
 * flight — with no error anywhere, because the wire value stays a valid
 * member of the enum, just a different one. New values go LAST, always.
 */
export enum Control {
  CarCallLock = 0,
  CarCallUnlock = 1,
  RearCarCallLock = 2,
  RearCarCallUnlock = 3,
  UpHallCallLock = 4,
  UpHallCallUnlock = 5,
  UpRearHallCallLock = 6,
  UpRearHallCallUnlock = 7,
  DownHallCallLock = 8,
  DownHallCallUnlock = 9,
  DownRearHallCallLock = 10,
  DownRearHallCallUnlock = 11,
  EnergizeCarCall = 12,
  EnergizeRearCarCall = 13,
  EnergizeUpHallCall = 14,
  EnergizeUpRearHallCall = 15,
  EnergizeDownHallCall = 16,
  EnergizeDownRearHallCall = 17,
  SecureCarCall = 18,
  SecureRearCarCall = 19,
  VIP = 20,
  OpenDoor = 21,
  CloseDoor = 22,
  IndependentService = 23,
  OutOfService = 24,
  CarToLobby = 25,
  RunUp = 26,
  RunDown = 27,
  Stop = 28,
  DisableDoor = 29,
  BypassHallCall = 30,
  ParkAndShutdown = 31,
  OpenFrontDoor = 32,
  CloseFrontDoor = 33,
  DisableCarCallsInclusive = 34,
  DisableCarCallsExclusive = 35,
  ReturnToNormal = 36,
  AttendantService = 37,
  JailOperation = 38,
  JailOpenFrontDoor = 39,
  JailOpenRearDoor = 40,
  JailCloseFrontDoor = 41,
  JailCloseRearDoor = 42,
  JailCancelCarCalls = 43,
  ShuttleService = 44,
  ShuttleFloor = 45,
  SwingOperation = 46,
  SabbathOperation = 47,
  FloodOperation = 48,
  AutoStop = 49,
  EmergencyAlarmAcknowledge = 50,
  EnergizeUpAuxHallCall = 51,
  EnergizeUpAuxRearHallCall = 52,
  EnergizeDownAuxHallCall = 53,
  EnergizeDownAuxRearHallCall = 54,
  GenericOutput = 55,
}
